import { Controller } from 'stimulus'

const localStorageKey = 'cookieMessageDismissed'

export default class extends Controller {
  close(_e, dismissed = true) {
    if (dismissed) localStorage.setItem(localStorageKey, new Date())
    this.element.style.display = 'none'
    document.getElementsByTagName('body')[0].classList.remove('cookiebar-open')
  }

  connect() {
    // Hide cookie bar on load if it has already been dismissed once. Protect against legacy browsers that don't have localStorage
    try {
      if (localStorage.getItem(localStorageKey)) {
        this.close(null, false)
      } else {
        document.getElementsByTagName('body')[0].classList.add('cookiebar-open')
      }
    } catch (e) {
      console.log('Failed to load cookie notification: ' + e.message)
    }
  }
}
